import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SeTakebackTransport } from '../model/supplementary-equipment-take-back.model';
import { AppServerAPI, Identity } from '@sdbn/common';

@Injectable({
  providedIn: 'root'
})
export class SupplementaryEquipmentTakeBackService {

  constructor(
    private appServerAPI: AppServerAPI,
  ) { }

  getTransport(transportIdentity: Identity): Observable<SeTakebackTransport> {
    return this.appServerAPI.execute<SeTakebackTransport>('/client/control/supplementaryequipment/takeback/transport', transportIdentity);
  }

  saveTransport(transport: SeTakebackTransport): Observable<any> {
    return this.appServerAPI.execute<any>('/client/control/supplementaryequipment/takeback/save', transport);
  }

}
